/**
 * Pure helpers for latest host WhatsApp confirmation status on raza event Details.
 */

import { formatDisplayDateTime } from "@/utils/date-format";

export type LatestHostConfirmation = {
  status?: string | null;
  sentAt?: string | Date | null;
  deliveredAt?: string | Date | null;
  readAt?: string | Date | null;
  errorMessage?: string | null;
  createdAt?: string | Date | null;
};

export function hostConfirmationStatusLabel(status: unknown): string {
  const s = status == null ? "" : String(status).trim().toUpperCase();
  switch (s) {
    case "SENT":
      return "Sent";
    case "DELIVERED":
      return "Delivered";
    case "READ":
      return "Read";
    case "FAILED":
      return "Failed";
    case "PENDING":
      return "Pending";
    default:
      return s ? s : "—";
  }
}

/** MUI Chip `color` prop values that map to theme palette. */
export function hostConfirmationChipColor(
  status: unknown
): "default" | "success" | "error" | "info" | "warning" {
  const s = status == null ? "" : String(status).trim().toUpperCase();
  switch (s) {
    case "READ":
    case "DELIVERED":
      return "success";
    case "SENT":
      return "info";
    case "FAILED":
      return "error";
    case "PENDING":
      return "warning";
    default:
      return "default";
  }
}

export function hostConfirmationStatusTimestamp(
  row: LatestHostConfirmation | null | undefined
): string {
  if (!row) return "";
  const status = row.status == null ? "" : String(row.status).trim().toUpperCase();
  const preferred =
    status === "READ"
      ? row.readAt
      : status === "DELIVERED"
        ? row.deliveredAt
        : status === "SENT"
          ? row.sentAt
          : (row.sentAt ?? row.createdAt);
  const value = preferred ?? row.createdAt;
  return formatDisplayDateTime(value, { empty: "" });
}
